import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { siteConfig } from '../config/siteConfig';

function NotFound() {
  const sectionStyle = {
    padding: 'clamp(3rem, 8vw, 8rem) 0'
  };

  const cardStyle = {
    backgroundColor: 'white',
    padding: 'clamp(1.5rem, 4vw, 2rem)',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    border: '1px solid #e5e7eb',
    textAlign: 'center'
  };

  return (
    <>
      <Helmet>
        <title>Page Not Found | Flood & Fire Pros</title>
        <meta name="description" content="The page you're looking for doesn't exist. Find restoration services, contractors, and resources on Flood & Fire Pros." />
      </Helmet>

      <section style={sectionStyle}>
        <div className="ffp-container-reading">
          <div className="max-w-2xl mx-auto">
            <div style={cardStyle}>
              {/* 404 Icon */}
              <div className="text-6xl mb-6">🚧</div>
              
              <h1 style={{
                fontSize: 'clamp(2rem, 5vw, 3rem)',
                fontFamily: siteConfig?.fonts?.heading || 'Montserrat, sans-serif',
                fontWeight: '700',
                marginBottom: '1rem',
                color: '#0c2c47'
              }}>
                404 - Page Not Found
              </h1>
              
              <p style={{
                fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                fontFamily: siteConfig?.fonts?.body || 'Open Sans, sans-serif',
                color: '#666',
                marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                Sorry, the page you're looking for doesn't exist or has been moved. 
                Don't worry - we can help you find what you need!
              </p>

              {/* Quick Navigation */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                <Link
                  to="/get-help-now"
                  className="flex items-center justify-center gap-2 bg-[#ea5416] hover:bg-[#d14912] text-white px-6 py-3 rounded-lg font-montserrat font-semibold transition-colors"
                >
                  🚨 Emergency Help
                </Link>
                <Link
                  to="/find-contractors"
                  className="flex items-center justify-center gap-2 bg-[#0c2c47] hover:bg-[#1b3a57] text-white px-6 py-3 rounded-lg font-montserrat font-semibold transition-colors"
                >
                  🔍 Find Contractors
                </Link>
              </div>

              {/* Popular Links */}
              <div className="border-t pt-6">
                <h3 className="text-lg font-bold text-[#0c2c47] mb-4">Popular Pages</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                  <Link to="/water-damage-restoration" className="text-gray-600 hover:text-[#ea5416] transition-colors py-1">Water Damage Restoration</Link>
                  <Link to="/fire-damage-restoration" className="text-gray-600 hover:text-[#ea5416] transition-colors py-1">Fire Damage Restoration</Link>
                  <Link to="/mold-remediation" className="text-gray-600 hover:text-[#ea5416] transition-colors py-1">Mold Remediation</Link>
                  <Link to="/for-contractors" className="text-gray-600 hover:text-[#ea5416] transition-colors py-1">For Contractors</Link>
                  <Link to="/about" className="text-gray-600 hover:text-[#ea5416] transition-colors py-1">About Us</Link>
                  <Link to="/contact" className="text-gray-600 hover:text-[#ea5416] transition-colors py-1">Contact</Link>
                  <Link to="/resources" className="text-gray-600 hover:text-[#ea5416] transition-colors py-1">Resources</Link>
                  <Link to="/faq" className="text-gray-600 hover:text-[#ea5416] transition-colors py-1">FAQ</Link>
                </div>
              </div>

              {/* Back to Home */}
              <div className="mt-6">
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 text-[#ea5416] hover:text-[#d14912] font-semibold transition-colors"
                >
                  ← Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Help Section */}
      <section style={{
        backgroundColor: '#f8f9fa',
        padding: 'clamp(2rem, 5vw, 4rem) 0'
      }}>
        <div className="ffp-container-reading text-center">
          <h2 style={{
            fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            fontFamily: siteConfig?.fonts?.heading || 'Montserrat, sans-serif',
            fontWeight: '700',
            marginBottom: '1rem',
            color: '#0c2c47'
          }}>
            Still Need Help?
          </h2>
          <p style={{
            fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
            fontFamily: siteConfig?.fonts?.body || 'Open Sans, sans-serif',
            color: '#666',
            marginBottom: '2rem',
            maxWidth: '600px',
            margin: '0 auto 2rem auto'
          }}>
            Our team is here to help you find the restoration services or information you need.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-[#0c2c47] hover:bg-[#1b3a57] text-white px-8 py-3 rounded-lg font-montserrat font-semibold transition-colors"
            >
              Contact Support
            </Link>
            <Link
              to="/sitemap"
              className="bg-white hover:bg-gray-50 text-[#0c2c47] px-8 py-3 rounded-lg font-montserrat font-semibold border border-[#0c2c47] transition-colors"
            >
              View Sitemap
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default NotFound;